import {Injectable} from '@angular/core';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {RootDynamicComponentHelper} from "@shared/helpers/root-dynamic-component-helper";
import {Api} from "@shared/constants/common-field.constants";
import {take} from "rxjs/operators";
import {CommandService} from "@core/services/command.service";
import {Router} from "@angular/router";
import {DialogService} from "@shared/services/dialog-service";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {SnackBarService} from "@core/services/snack-bar.service";
import {FileManagementService} from "@core/services/file-management.service";
import {Store} from "@ngrx/store";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {PlatformSidebarService} from "@shared/components/platform-sidebar/store/platform-sidebar.service";
import {FuseSidebarService} from "@barebone-fuse/@fuse/components/sidebar/sidebar.service";

@Injectable({
  providedIn: 'root',
})

export class PublicationHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  magicLinkModel: MagicLinkModel;
  selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;

  constructor(private commandService: CommandService,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
  ) {
  }

  executeCommand(command: PlatformCommand) {
    console.log('publication-handler', command);

    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this, null);
        return;
      }
    }

    this.executeCommandToApi(command);
  }


  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  destroy(): void {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private handleUpdateViewCommandResponse(response: PlatformCommandResponse) {
    console.log('commandState', response);
    if (response.fieldValues['PlatformLinkModel']) {

      this.magicLinkModel = response.fieldValues['PlatformLinkModel'];

      this.magicLinkModelValueChangedHandler({
        id: 'PlatformToolContainerComponent', value: response.fieldValues['PlatformLinkModel'],
        magicLinkModel: this.magicLinkModel
      });
    } else {
      console.log('Platform link model not found');
      this.fuseSplashScreenService.hide();
    }
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    this.handleAction($event);
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      command.projectId = '[PROJECT_ID]';
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          this.handleUpdateViewCommandResponse(commandResponse);
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            const duration = commandResponse.fieldValues['ErrorMessage'].length * 80;
            this.snackBarService.showError(commandResponse.fieldValues['ErrorMessage']);
          }
          this.invalidateSubject.invalidate();
        },
        error => {
          console.log(error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }


  private handleAction(event: any) {
    const actionId = event?.action?.id ?? event?.action?.Id;
    if (actionId === 'Download') {
      this.downloadPublication(event.item.cells);
      return true;
    }
    if (actionId === 'Delete') {
      let deletePublicationCommand = this.magicLinkModel.additionalCommands['Delete'];
      deletePublicationCommand.fieldValues["PublicationId"] = event.item.cells.PublicationId.value;
      this.executeCommandToApi(deletePublicationCommand);
      return true;
    }
  }

  private downloadPublication(cells: any) {
    const entryId = cells?.UploadFileEntryId?.value;
    if (!entryId) {
      this.snackBarService.showError('This publication has no uploaded file to download.');
      return;
    }
    this.fuseSplashScreenService.show();
    this.fileManagementService.downloadClientFileWithId(entryId).pipe(take(1)).subscribe(payload => {
        this.fuseSplashScreenService.hide();
        this.fileManagementService.openSaveFileWindow(payload, `${cells?.Title?.value || 'publication'}.zip`);
      },
      () => this.fuseSplashScreenService.hide());
  }
}


